<script setup>
import { computed } from 'vue';

const props = defineProps({
    page: {
        type: Number,
        required: true
    },
    pageSize: {
        type: Number,
        required: true
    },
    totalItems: {
        type: Number,
        required: true
    },
    itemsPerPageOptions: {
        type: Array,
        default: () => [10, 20, 50, 100]
    }
});

const emit = defineEmits(['update:page', 'update:pageSize']);

const totalPages = computed(() => Math.ceil(props.totalItems / props.pageSize));

const handleFirst = () => emit('update:page', 1);
const handlePrev = () => emit('update:page', Math.max(1, props.page - 1));
const handleNext = () =>
    emit('update:page', Math.min(totalPages.value, props.page + 1));
const handleLast = () => emit('update:page', totalPages.value);

const handlePageSizeChange = (val) => {
    emit('update:pageSize', val);
    emit('update:page', 1);
};
</script>

<template>
    <div class="pagination-row">
        <span class="items-per-page-label">Items per page:</span>
        <v-select
            :model-value="pageSize"
            :items="itemsPerPageOptions"
            class="items-per-page-select"
            hide-details
            density="compact"
            style="width: 90px"
            @update:model-value="handlePageSizeChange"
        />
        <span class="pagination-info">
            {{ (page - 1) * pageSize + 1 }}-{{
                Math.min(page * pageSize, totalItems)
            }}
            of {{ totalItems }}
        </span>
        <v-btn
            icon
            variant="plain"
            :disabled="page === 1"
            @click="handleFirst"
            color="grey"
        >
            <v-icon>mdi-page-first</v-icon>
        </v-btn>
        <v-btn
            icon
            variant="plain"
            :disabled="page === 1"
            @click="handlePrev"
            color="grey"
        >
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
            icon
            variant="plain"
            :disabled="page >= totalPages"
            @click="handleNext"
            color="grey"
        >
            <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
            icon
            variant="plain"
            :disabled="page >= totalPages"
            @click="handleLast"
            color="grey"
        >
            <v-icon>mdi-page-last</v-icon>
        </v-btn>
    </div>
</template>

<style scoped>
.pagination-row {
    display: flex;
    align-items: center;
    gap: 16px;
}
.items-per-page-label {
    font-size: 0.95rem;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
    margin-right: 4px;
    white-space: nowrap;
}
.items-per-page-select {
    width: 90px;
    min-width: 90px;
}
.pagination-info {
    font-size: 0.95rem;
    color: rgba(0, 0, 0, 0.87);
    margin-left: 8px;
    margin-right: 8px;
    white-space: nowrap;
}
</style>
